/* ZonaPhone — núcleo del cotizador Trade-In (sin DOM).
 * Lo usa assets/zp-tradein-quote.js y lo testea scripts/zp-tradein/test.mjs.
 * Costes = los del Excel "Tasador iPhone ZonaPhone" (metaobjeto tasacion_iphone);
 * el estado va por grados (v2, estilo itsworthmore):
 *   estado  = round((base − ajuste(capacidad)) × (1 − %grado / 100))
 *   crédito = estado − Σ averías (solo grado "averias") − batería (< 80 %)
 *   dinero  = floor(crédito × (100 − %) / 100)
 *   dinero < mínimo -> sin precio online.
 * El precio de la tabla es el de CRÉDITO (decisión de Santiago, 2026-09-25): el
 * dinero es un −10 %, aunque al cliente se le presenta como "+10 % en crédito".
 * ajuste(capacidad) conserva el signo del Excel: positivo resta, negativo suma.
 */
(function (root) {
  'use strict';

  var REPAIRS = ['pantalla', 'bateria', 'camara', 'chasis', 'botones', 'puerto'];
  // Averías que se marcan con el grado "averias" (la batería va en su propio paso).
  var DAMAGE = ['pantalla', 'camara', 'chasis', 'botones', 'puerto'];
  var GRADES = ['nuevo', 'muy_bueno', 'bueno', 'averias'];

  // El email lo lee el equipo: siempre en español, sea cual sea el idioma de la web.
  var ES = {
    pantalla: 'Pantalla', bateria: 'Batería', camara: 'Cámara trasera',
    chasis: 'Chasis / Tapa', botones: 'Botones', puerto: 'Puerto de carga', esim: 'Solo eSIM'
  };
  var GRADE_ES = {
    nuevo: 'Como nuevo', muy_bueno: 'Muy bueno', bueno: 'Bueno',
    averias: 'Tiene algo roto o que no funciona'
  };
  var REASONS = {
    other: 'Otro dispositivo', power: 'No enciende',
    min: 'Oferta por debajo del mínimo', nodata: 'Tasador sin datos'
  };
  var DELIVERY = {
    store: 'Traerlo a la tienda', courier: 'Envío por mensajería',
    online: 'Junto con una compra en la web'
  };

  function toInt(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = Number(v);
    return isFinite(n) ? Math.round(n) : null;
  }

  // "64GB" -> 64, "1TB" -> 1024 (solo para ordenar).
  function capSize(key) {
    var m = /^(\d+)\s*(GB|TB)$/i.exec(String(key).trim());
    if (!m) return null;
    return Number(m[1]) * (m[2].toUpperCase() === 'TB' ? 1024 : 1);
  }

  function normalizeModels(raw, warn) {
    warn = warn || function () {};
    if (!Array.isArray(raw)) return [];
    if (raw.length === 50) warn('[zp-tq] 50 modelos: Liquid corta metaobjects.values en 50, puede faltar alguno');
    var out = [];
    raw.forEach(function (r) {
      if (!r || r.activo === false) return;
      var base = toInt(r.precio_base);
      if (!r.handle || !r.modelo || base === null) { warn('[zp-tq] modelo inválido', r.handle); return; }
      var costs = {};
      REPAIRS.forEach(function (k) { costs[k] = toInt(r[k]) || 0; });
      costs.esim = toInt(r.descuento_esim) || 0; // 0 = el modelo no pregunta SIM/eSIM
      var src = r.capacidades;
      if (typeof src === 'string') { try { src = JSON.parse(src); } catch (e) { src = null; } }
      var caps = [];
      if (src && typeof src === 'object') {
        Object.keys(src).forEach(function (k) {
          var adj = toInt(src[k]);
          var size = capSize(k);
          if (adj === null || size === null) { warn('[zp-tq] capacidad inválida', r.handle, k); return; }
          caps.push({ key: String(k).trim().toUpperCase(), size: size, adj: adj });
        });
      }
      if (!caps.length) { warn('[zp-tq] sin capacidades', r.handle); return; }
      caps.sort(function (a, b) { return a.size - b.size; });
      out.push({
        handle: r.handle, name: String(r.modelo), order: toInt(r.orden) || 0,
        base: base, costs: costs, caps: caps, img: r.foto ? String(r.foto) : null
      });
    });
    out.sort(function (a, b) { return (b.order - a.order) || (a.name < b.name ? -1 : 1); });
    return out;
  }

  function gradePct(grade, settings) {
    var g = settings.gradePct || {};
    return Number(g[grade]) || 0;
  }

  // answers: { esim: true si es solo eSIM, grade: 'nuevo'|'muy_bueno'|'bueno'|'averias',
  //            repairs: { pantalla: true, ... }, bateria: true si la salud es < 80 % }.
  // null si la capacidad no existe.
  // waived (opcional, tasador interno): { grade, bateria, pantalla, ... } = líneas
  // perdonadas; no se restan pero salen en `lines` con waived: true. Sin waived,
  // el resultado es exactamente el de la web.
  function quote(model, capKey, answers, settings, waived) {
    var cap = null;
    model.caps.forEach(function (c) { if (c.key === capKey) cap = c; });
    if (!cap) return null;
    answers = answers || {};
    var costs = model.costs || {};
    var lines = [];
    var line = function (l, isWaived) { if (waived) l.waived = !!isWaived; lines.push(l); };
    if (cap.adj !== 0) line({ id: 'cap', amount: -cap.adj });
    var pre = model.base - cap.adj;
    var pct = gradePct(answers.grade, settings);
    var graded = Math.round(pre * (100 - pct) / 100);
    var gradeWaived = !!(waived && waived.grade);
    if (graded !== pre) line({ id: 'grade', amount: graded - pre, pct: pct }, gradeWaived);
    var credit = gradeWaived ? pre : graded;
    var take = function (k) {
      var cost = costs[k] || 0;
      var w = !!(waived && waived[k]);
      if (!w) credit -= cost;
      line({ id: k, amount: -cost }, w);
    };
    if (answers.esim === true && costs.esim) take('esim');
    if (answers.grade === 'averias' && answers.repairs) {
      DAMAGE.forEach(function (k) { if (answers.repairs[k] === true) take(k); });
    }
    if (answers.bateria === true) take('bateria');
    var cash = Math.floor(credit * (100 - settings.creditBonusPct) / 100);
    return { ok: cash >= settings.minOffer, base: model.base, credit: credit, cash: cash, lines: lines };
  }

  // "Hasta X €" de la tarjeta: crédito con la capacidad que más suma, como nuevo, sin averías.
  function maxCredit(model, settings) {
    var best = null;
    model.caps.forEach(function (c) { if (!best || c.adj < best.adj) best = c; });
    var q = quote(model, best.key, { grade: 'nuevo', bateria: false }, settings);
    return q && q.ok ? q.credit : null;
  }

  function eur(n) { return (n > 0 ? '+' : '') + n + ' €'; }

  // Respuestas del cliente, en español (las lee el equipo).
  function deviceLines(state) {
    var a = state.answers || {};
    var L = [];
    if (state.model) {
      L.push('Modelo: ' + state.model.name);
      if (state.capKey) L.push('Capacidad: ' + state.capKey);
      if (state.noPriceReason === 'power') L.push('Enciende: NO');
      if (a.esim === true) L.push('SIM: solo eSIM');
      else if (a.esim === false) L.push('SIM: física');
      if (a.grade) L.push('Estado: ' + GRADE_ES[a.grade]);
      if (a.grade === 'averias' && a.repairs) {
        var broken = DAMAGE.filter(function (k) { return a.repairs[k] === true; }).map(function (k) { return ES[k]; });
        L.push('Averías: ' + (broken.join(', ') || '-'));
      }
      if (a.bateria === true) L.push('Batería: por debajo del 80 %');
      else if (a.bateria === false) L.push('Batería: 80 % o más');
    } else {
      L.push('Dispositivo: ' + (state.otherDevice || '-'));
    }
    return L;
  }

  function breakdownLines(state, q) {
    var L = ['Precio base: ' + q.base + ' €'];
    q.lines.forEach(function (l) {
      var label = l.id === 'cap' ? 'Capacidad ' + state.capKey
        : l.id === 'grade' ? 'Estado (-' + l.pct + ' %)' : ES[l.id];
      L.push(label + ': ' + eur(l.amount));
    });
    return L;
  }

  // Trade-in al comprar (carrito): la tasación viaja como atributos del carrito y
  // queda en el pedido (admin → "Detalles adicionales"). Ya compró, así que se paga
  // SIEMPRE el precio de crédito, por transferencia o en crédito (decisión de
  // Santiago, 2026-10-05). Claves sin "_" = visibles para el equipo, en español;
  // "_zp_tradein*" = datos sueltos (Liquid no parsea JSON) para pintar la tarjeta
  // del carrito (snippets/zp-cart-tradein.liquid) en el idioma del cliente.
  // state: { model, capKey, answers, payout: 'transfer'|'credit', delivery: 'store'|'courier', locale }
  // now: Date (inyectable para tests). termsVersion: versión de las condiciones aceptadas.
  var CART_PAYOUT = { transfer: 'Transferencia bancaria', credit: 'Crédito ZonaPhone' };
  var CART_DELIVERY = { store: 'Lo trae a la tienda', courier: 'Envío por correo (etiqueta prepagada)' };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function cartAttributes(state, q, now, termsVersion) {
    var device = state.model.name + ' ' + state.capKey;
    var stamp = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate()) +
      ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    var detail = deviceLines(state).concat([''], breakdownLines(state, q), [
      'Oferta: ' + q.credit + ' € (precio de crédito; compra en la web)',
      'Cobro: ' + (CART_PAYOUT[state.payout] || '-'),
      'Entrega: ' + (CART_DELIVERY[state.delivery] || '-'),
      'Idioma: ' + (state.locale || '-')
    ]);
    return {
      'Trade-in': device + ' · ' + q.credit + ' € · ' + (CART_PAYOUT[state.payout] || '-') + ' · ' + (CART_DELIVERY[state.delivery] || '-'),
      'Trade-in detalle': detail.join('\n'),
      'Trade-in condiciones': 'Aceptadas el ' + stamp + ' (versión ' + termsVersion + ')',
      '_zp_tradein': device,
      '_zp_tradein_value': String(q.credit),
      '_zp_tradein_img': state.model.img || ''
    };
  }
  // Para quitar el trade-in del carrito: Shopify borra los atributos con valor vacío.
  var CART_KEYS = ['Trade-in', 'Trade-in detalle', 'Trade-in condiciones', '_zp_tradein', '_zp_tradein_value', '_zp_tradein_img'];
  function clearCartAttributes() {
    var o = {};
    CART_KEYS.forEach(function (k) { o[k] = ''; });
    return o;
  }

  // state: { model, capKey, answers, otherDevice, noPriceReason, payout, delivery, locale, comments }
  function buildBody(state, q, settings) {
    var device = state.model
      ? state.model.name + (state.capKey ? ' ' + state.capKey : '')
      : (state.otherDevice || 'Otro dispositivo');
    var head = 'TRADE-IN · ' + device + ' · ';
    if (q && q.ok) head += state.payout === 'cash' ? 'Dinero ' + q.cash + ' €' : 'Crédito ' + q.credit + ' €';
    else head += 'SIN PRECIO (' + (REASONS[state.noPriceReason] || REASONS.min) + ')';

    var L = [head, ''].concat(deviceLines(state));
    if (q) {
      L.push('');
      L = L.concat(breakdownLines(state, q));
      L.push('Oferta crédito: ' + q.credit + ' €');
      L.push('Oferta dinero: ' + q.cash + ' € (-' + settings.creditBonusPct + ' %)');
      if (q.ok) {
        L.push('Modalidad elegida: ' + (state.payout === 'cash' ? 'Dinero' : 'Crédito ZonaPhone (+' + settings.creditBonusPct + ' %)'));
      }
    }
    L.push('', 'Entrega: ' + (DELIVERY[state.delivery] || '-'));
    if (state.termsVersion) L.push('Condiciones del trade-in y privacidad: aceptadas (versión ' + state.termsVersion + ')');
    L.push('Idioma: ' + (state.locale || '-'));
    if (state.comments) L.push('', 'Comentarios: ' + state.comments);
    return L.join('\n');
  }

  root.ZPTradeinQuote = {
    REPAIRS: REPAIRS, DAMAGE: DAMAGE, GRADES: GRADES,
    normalizeModels: normalizeModels, quote: quote, maxCredit: maxCredit, buildBody: buildBody,
    cartAttributes: cartAttributes, clearCartAttributes: clearCartAttributes
  };
})(typeof window !== 'undefined' ? window : this);
